export default {
  bind: function (el) {
    el.setAttribute("novalidate", "novalidate");
    el.addEventListener("submit", function (event) {
      event.preventDefault();
    });
  },
};
